export const checkinModalConversation = {
  guestFallback: "Guest",
  conversationLabel: "Conversation:",
  replyOnWhatsAppLabel: "Reply on WhatsApp:",
  replyOnWhatsAppTooltip: "Reply on WhatsApp",
};
